if (!customElements.get("load-more")) {
  class LoadMore extends HTMLElement {
    constructor() {
      super();
      this.loadMoreWrapper = document.querySelector("#main-collection-product-grid");
      this.ajaxSectionToLoad = "collection-filters";
      this.wrapperID = "#products";
      this.wrapperIDSelector = "[data-products-wrapper]";

      this.initLoadMoreButtons();
    }

    /**
     * initLoadMoreButtons
     * @description Create the load more/prev buttons. Is also called again after fetch is done
     */
    initLoadMoreButtons() {
      this.currentPage = this.querySelector("[data-current-page]");
      this.currentPageValue = parseInt(this.currentPage.value);
      this.totalPages = this.querySelector("[data-total-pages]");
      this.totalPagesValue = parseInt(this.totalPages.value);

      // hide the buttons based on the page displayed
      this.totalPagesValue === this.currentPageValue &&
      this.querySelector('[data-collection-load-trigger="next"]') != null
        ? this.querySelector('[data-collection-load-trigger="next"]').classList.add("hidden")
        : null;

      this.currentPageValue === 1 &&
      this.querySelector('[data-collection-load-trigger="prev"]') != null
        ? this.querySelector('[data-collection-load-trigger="prev"]').classList.add("hidden")
        : null;

      this.loadTrigger = this.querySelectorAll("[data-collection-load-trigger]");
      this.loadTrigger.forEach((trigger) =>
        trigger.addEventListener("click", this.loadItems.bind(this)),
      );
    }

    /**
     * loadItems
     * @description Gets the url to fetch and toggles the load items/loading text
     * @param {Object} event
     */
    loadItems(event) {
      event.preventDefault();
      event.stopImmediatePropagation();
      const linkElement = event.target.closest("a");
      const direction = linkElement.dataset.collectionLoadTrigger;
      linkElement.querySelector("[data-load-text]").classList.add("hidden");
      linkElement.querySelector("[data-loader]").classList.remove("hidden");

      const url = `${linkElement.href}&section_id=${this.ajaxSectionToLoad}`;
      this.renderProductsFromFetch(url, linkElement.href, direction);
    }

    /**
     * renderProductsFromFetch
     * @description Renders the products based on the fetch url data.
     * @param {String} url
     * @param {String} page
     * @param {String} direction
     */
    renderProductsFromFetch(url, page, direction) {
      fetch(url)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(responseText, "text/html");
          if (html.querySelector(`${this.wrapperID}`)) {
            // update the wrapper with the new products
            const newContent = html.querySelector(
              `${this.wrapperID} ${this.wrapperIDSelector}`,
            ).innerHTML;
            const newElement = document.createRange().createContextualFragment(newContent);

            // depending on the direction of the click, append or prepend the products and update the pagination
            if (direction == "next") {
              this.loadMoreWrapper.querySelector(`${this.wrapperIDSelector}`).append(newElement);
              // update the pagination
              const paginationNextHtml = html.querySelector("#pagination-next").innerHTML;
              this.loadMoreWrapper.querySelector("#pagination-next").innerHTML = paginationNextHtml;
            } else {
              this.loadMoreWrapper.querySelector(`${this.wrapperIDSelector}`).prepend(newElement);
              // update the pagination
              const paginationPrevHtml = html.querySelector("#pagination-prev").innerHTML;
              this.loadMoreWrapper.querySelector("#pagination-prev").innerHTML = paginationPrevHtml;
            }

            // rebind the event listener
            this.initLoadMoreButtons();

            // update url
            this.updateURLHash(page);

            // update the hidden input with the new value
            this.querySelector("[data-current-page]").value = page.split("page=")[1];
          }
        });
    }

    /**
     * updateURLHash
     * @param {String} url
     */
    updateURLHash(url) {
      history.pushState("", "", url);
    }
  }

  window.LoadMore = LoadMore;

  customElements.define("load-more", LoadMore);
}
